<div class="top-bar-categories flex align-orders-center">
  <div class="title flex align-orders-center me-auto">
    <i _ngcontent-serverapp-c11="" class="fas fa-hand-holding-usd me-3"></i>
    <h5>Mis centros de costo</h5>
  </div>
  <div>
    <button class="btn btn-link btn-sm" (click)="agregarVinFlota()">
      <i class="fas fa-plus fa-lg me-2"></i>Agregar
      <span class="hiddem sm:inline p-0">centro de costo</span>
    </button>
  </div>
</div>

<div class="row m-0">
  <div class="col-lg-12">
    <div class="card mt-3">
      <div class="card-body table-responsive" style="min-height: 200px">
        <app-loading-element
          class="pt-3"
          [text]="'Cargando centros de costo'"
          *ngIf="cargando"
        >
        </app-loading-element>
        <div class="block md:hidden">
          <div
            [ngClass]="{ dropcart__totals: i > 0 }"
            style="font-size: 0.85rem"
            *ngFor="let item of centrosCosto; let i = index"
          >
            <table>
              <tr>
                <th class="fw-bold titilo-w">Código</th>
                <td class="text-start">{{ item.code }}</td>
              </tr>
              <tr>
                <th class="fw-bold titilo-w">Nombre</th>
                <td class="text-start">{{ item.name }}</td>
              </tr>
              <tr>
                <th class="fw-bold titilo-w">Acciones</th>
                <td class="text-start">
                  <button class="btn btn-sm btn-link" (click)="(true)">
                    <i class="fas fa-edit fa-lg me-1"></i>Editar
                  </button>
                  <button
                    class="btn btn-sm btn-link text-red-500"
                    (click)="eliminarCentroCosto(item)"
                  >
                    <i class="fas fa-trash-alt text-red-500 me-1 fa-lg"></i
                    >Eliminar
                  </button>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="hidden md:block">
          <div
            [ngStyle]="{ display: centrosCosto.length > 0 ? 'block' : 'none' }"
          >
            <table
              datatable
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTrigger1"
              class="hover datatable table-shadow"
              style="width: 100%"
            >
              <thead class="table-dark" *ngIf="centrosCosto.length > 0">
                <tr>
                  <th>Código</th>
                  <th>Nombre</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of centrosCosto">
                  <td>{{ item.code }}</td>
                  <td nowrap>{{ item.name | capitalizeFirst }}</td>
                  <td style="font-size: 0.9rem">
                    <button
                      class="btn btn-sm btn-link"
                      (click)="actualizarCentroCosto(item)"
                    >
                      <i class="fas fa-edit fa-lg me-1"></i>Editar
                    </button>
                    <button
                      class="btn btn-sm btn-link text-red-500"
                      (click)="eliminarCentroCosto(item)"
                    >
                      <i class="fas fa-trash-alt text-red-500 me-1 fa-lg"></i
                      >Eliminar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-center" *ngIf="centrosCosto?.length == 0">
            Sin Registros
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
